import {Component} from '@angular/core';
import {ListGridTriggerComponent} from '../list-grid-trigger/list-grid-trigger.component';
import {RightViewComponent} from '../right-view/right-view.component';

@Component({
  selector: 'app-blog-view',
  templateUrl: './blog-view.component.html',
  imports: [
    ListGridTriggerComponent,
    RightViewComponent
  ],
  styleUrls: ['./blog-view.component.scss']
})
export class BlogViewComponent {
}
